export const ids = [
	'each',
	'area',
	'length_and_height',
	'length',
	'area_and_height',

	'inclined_area',
	'inclined_length',

	'each_length',
	'each_length_and_height',
] as const;
